export const QUERY_KEYS = { EMOJI_DATA: "emoji-data" };
